import React, { Fragment } from 'react';
import './styles.css';
import { Header } from './Header';
import { Why } from './Why';
import { Features } from './Features';
import { GetStarted } from './GetStarted';
import { Discussion } from './Discussion';
import { NotIncluded } from './NotIncluded';
export var Home = function () {
    return (React.createElement(Fragment, null,
        React.createElement(Header, null),
        React.createElement(Why, null),
        React.createElement(Features, null),
        React.createElement(NotIncluded, null),
        React.createElement(GetStarted, null),
        React.createElement(Discussion, null)));
};
